import {
  Card,
  Group,
  SimpleGrid,
  Stack,
  Text,
  ThemeIcon,
  UnstyledButton,
} from "@mantine/core";
import {
  IconArrowRight,
  IconBook,
  IconBuildingHospital,
  IconClipboardCheck,
  IconFlask,
  IconPill,
} from "@/lib/icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { PageHeader } from "@/components/PageHeader";

const ENTRIES = [
  {
    to: "/references/organizations",
    labelKey: "references.organizations",
    descKey: "references.organizations_desc",
    icon: IconBuildingHospital,
    color: "brand",
  },
  {
    to: "/references/examination-types",
    labelKey: "references.examination_types",
    descKey: "references.examination_types_desc",
    icon: IconClipboardCheck,
    color: "blue",
  },
  {
    to: "/references/medications",
    labelKey: "references.medications",
    descKey: "references.medications_desc",
    icon: IconPill,
    color: "blue",
  },
  {
    to: "/references/mkb10",
    labelKey: "references.mkb10",
    descKey: "references.mkb10_desc",
    icon: IconBook,
    color: "blue",
  },
  {
    to: "/references/lab-tests",
    labelKey: "references.lab_tests",
    descKey: "references.lab_tests_desc",
    icon: IconFlask,
    color: "blue",
  },
  {
    to: "/references/lab-templates",
    labelKey: "lab_templates.title",
    descKey: "lab_templates.subtitle",
    icon: IconFlask,
    color: "violet",
  },
];

export function ReferencesHomePage() {
  const { t } = useTranslation();
  return (
    <Stack gap="lg">
      <PageHeader title={t("references.title")} />
      <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
        {ENTRIES.map((e) => {
          const Icon = e.icon;
          return (
            <UnstyledButton key={e.to} component={Link} to={e.to}>
              <Card padding="lg" h="100%">
                <Group justify="space-between" align="flex-start" wrap="nowrap">
                  <Stack gap="xs">
                    <ThemeIcon size={48} radius="xl" variant="light" color={e.color}>
                      <Icon size={24} strokeWidth={1.6} />
                    </ThemeIcon>
                    <Text fw={700} size="md">
                      {t(e.labelKey)}
                    </Text>
                    <Text c="dimmed" size="xs">
                      {t(e.descKey, { defaultValue: "" })}
                    </Text>
                  </Stack>
                  <IconArrowRight size={18} strokeWidth={1.6} color="var(--mantine-color-gray-5)" />
                </Group>
              </Card>
            </UnstyledButton>
          );
        })}
      </SimpleGrid>
    </Stack>
  );
}
